import { getProxiedImage } from './getImage';

export const getAvatar = (avatar, platform, backblaze = false) => {
  const imagesStaticUrl = 'https://f002.backblazeb2.com/file/all-gather-media/';
  switch (platform) {
    case 'news':
    case 'newspaper':
      return getProxiedImage(avatar?.replace('_normal', ''));
    case 'story':
    case 'instagram':
    case 'twitter':
    case 'virasty':
    case 'telegram':
      return getProxiedImage(imagesStaticUrl + avatar?.replace('_normal', ''));
    default:
      return getProxiedImage(backblaze ? imagesStaticUrl + avatar : avatar);
  }
};
